import moment from 'moment-timezone'

/**
 * Convert UTC time to local time
 * @param {string} utcTime - The UTC time to convert
 * @param {string} timezone - The timezone to convert to
 * @returns {string} The local time
 */
export function convertUTCToLocalTime(utcTime, timezone) {
  try {
    return moment.utc(utcTime).tz(timezone)
  } catch (error) {
    return moment.utc(utcTime)
  }
}
